import { post } from "../../until/axios_instans";

// oos图片的
export function getImageOssBaseurl(data) {
  // console.log(data);
  return post("/api/gongyong/api/v1/address/type", data);
}
